module.exports = __webpack_public_path__ + "img/page404.949328f7.svg";